export interface FaqItem {
  question: string;
  answer: string;
  open: boolean;
}

export const HELP_FAQS: FaqItem[] = [
  {
    question: 'How do I get started with orderYaa ERP?',
    answer: 'Create a free account, then pick the modules you need during onboarding. You can start using the platform immediately — no payment method required.',
    open: true,
  },
  {
    question: 'Can I add or remove modules later?',
    answer: 'Yes. You can enable or disable modules at any time from your account settings without losing your existing data.',
    open: false,
  },
  {
    question: 'Is my business data secure?',
    answer: 'All data in transit is encrypted with TLS/SSL and data at rest is encrypted with AES-256. See our Privacy Policy for full details.',
    open: false,
  },
  {
    question: 'How do I reach support?',
    answer: 'Use any of the options above — book a meeting, email us, or message us on WhatsApp. We typically respond within one business day.',
    open: false,
  },
  {
    question: 'Do you offer a free trial?',
    answer: 'Yes, core onboarding and the modules you select are free to use for as long as your account stays active, with no card required to start.',
    open: false,
  },
];
